import { ESTADOS_RESERVA } from '@/constants/reservaConstants';
import actividadIcon from '@/assets/icons/servicios/actividad.svg';
import alquilerIcon from '@/assets/icons/servicios/alquiler.svg';
import clasesIcon from '@/assets/icons/servicios/clases.svg';
import competicionIcon from '@/assets/icons/servicios/competicion.svg';
import festivalIcon from '@/assets/icons/servicios/festival.svg';
import forfaitIcon from '@/assets/icons/servicios/forfait.svg';
import greenfeeIcon from '@/assets/icons/servicios/greenfee.svg';
import mascotaIcon from '@/assets/icons/servicios/mascota.svg';
import parkingIcon from '@/assets/icons/servicios/parking.svg';
import personalIcon from '@/assets/icons/servicios/personal.svg';
import relaxIcon from '@/assets/icons/servicios/relax.svg';
import restauracionIcon from '@/assets/icons/servicios/restauracion.svg';
import seguroIcon from '@/assets/icons/servicios/seguro.svg';
import transporteIcon from '@/assets/icons/servicios/transporte.svg';

export function getPaqueteBasicoForServicio(agrupacionesServicios, servicio) {
  const agrupacion = agrupacionesServicios.find(ags => ags.id === servicio.agrupacion.id);
  if (agrupacion.paqueteBasico) {
    return agrupacion.servicios.find(s => s.paqueteBasico);
  }
  return null;
}

export function isServicioContratable(reserva, servicio) {
  return !reserva.persisted || reserva.estado === ESTADOS_RESERVA.BLOQUEADA || !servicio.contratableSoloCreacion;
}

export function isServicioDescontratable(reserva, servicio) {
  return (
    servicio == null ||
    !reserva.persisted ||
    reserva.estado === ESTADOS_RESERVA.BLOQUEADA ||
    servicio.borrable ||
    servicio.justSelected
  );
}

export const getCategoriasServiciosMetaData = () => {
  return [
    {
      selector: 'forfait',
      icono: forfaitIcon,
    },
    {
      selector: 'restauracion',
      icono: restauracionIcon,
    },
    {
      selector: 'alquiler',
      icono: alquilerIcon,
    },
    {
      selector: 'clases',
      icono: clasesIcon,
    },
    {
      selector: 'transporte',
      icono: transporteIcon,
    },
    {
      selector: 'actividad',
      icono: actividadIcon,
    },
    {
      selector: 'seguro',
      icono: seguroIcon,
    },
    {
      selector: 'parking',
      icono: parkingIcon,
    },
    {
      selector: 'greenFee',
      icono: greenfeeIcon,
    },
    {
      selector: 'comfort',
      icono: relaxIcon,
    },
    {
      selector: 'festival',
      icono: festivalIcon,
    },
    {
      selector: 'personal',
      icono: personalIcon,
    },
    {
      selector: 'mascota',
      icono: mascotaIcon,
    },
    {
      selector: 'competicion',
      icono: competicionIcon,
    },
  ];
};
